import { getLocalChanges } from './commands';
import { relationshipDefs } from './relationships';
export const config = {
    modelDefs: {
        Block: {},
        BlockFocus: {},
        TrainingFocus: {},
        BlockDraftWorkoutLayer: {},
        BlockPublishTask: {},
        AthleteDraftWorkoutLayer: {},
        AmsClassicWorkout: {},
        BlockPrintTask: {},
        BlockPublishedWorkoutLayer: {},
        AthletePublishedWorkoutLayer: {},
        AthleteActualWorkoutLayer: {},
        AthleteModifiedPublishedWorkoutLayer: {},
        Track: {},
        AthleteTransferredBlock: {},
        AthleteTransferredTrack: {},
    },
    relationshipDefs,
    mutationDefs: {
        getChanges: getLocalChanges,
    },
    indexes: {
        Block: [
            {
                name: 'Block_blockId',
                fields: ['id'],
            },
        ],
        BlockFocus: [
            {
                name: 'BlockFocus_blockId_focusId',
                fields: ['blockId', 'focusId'],
            },
        ],
        TrainingFocus: [
            {
                name: 'TrainingFocus_focusId',
                fields: ['id'],
            },
        ],
        BlockDraftWorkoutLayer: [
            {
                name: 'BlockDraftWorkoutLayer_blockId',
                fields: ['blockId'],
            },
        ],
        BlockPublishTask: [
            {
                name: 'BlockPublishTask_blockId',
                fields: ['blockId'],
            },
        ],
        AthleteDraftWorkoutLayer: [
            {
                name: 'AthleteDraftWorkoutLayer_blockId',
                fields: ['blockId'],
            },
        ],
        AmsClassicWorkout: [
            {
                name: 'AmsClassicWorkout_workoutId',
                fields: ['workoutId'],
            },
        ],
        BlockPrintTask: [
            {
                name: 'BlockPrintTask_blockId',
                fields: ['blockId'],
            },
        ],
        BlockPublishedWorkoutLayer: [
            {
                name: 'BlockPublishedWorkoutLayer_blockId_version',
                fields: ['blockId', 'version'],
            },
        ],
        AthletePublishedWorkoutLayer: [
            {
                name: 'AthletePublishedWorkoutLayer_assignedDate_profileId',
                fields: ['assignedDate', 'profileId'],
            },
        ],
        AthleteModifiedPublishedWorkoutLayer: [
            {
                name: 'AthleteModifiedPublishedWorkoutLayer_profileId',
                fields: ['profileId'],
            },
        ],
        AthleteActualWorkoutLayer: [
            {
                name: 'AthleteActualWorkoutLayer_profileId',
                fields: ['profileId'],
            },
        ],
        Track: [
            {
                name: 'Track_teamId',
                fields: ['teamId'],
            },
        ],
        AthleteTransferredTrack: [
            {
                name: 'AthleteTransferredTrack_trackId',
                fields: ['trackId'],
            },
        ],
        AthleteTransferredBlock: [
            {
                name: 'AthleteTransferredBlock_blockId',
                fields: ['blockId'],
            },
        ],
    },
    syncGroupDefs: {
        lazyBootstrapModels: (syncGroup) => {
            switch (syncGroup.type) {
                case 'OrgCoach':
                    return [];
                case 'TeamCoach':
                    // TeamCoach just acts as the "syncing agent". It's linked in the main bootstrap
                    // so we have a sync group to pass sync actions to
                    return [];
                case 'TeamCoach_Timeline':
                    return [
                        'Block',
                        'BlockFocus',
                        'TrainingFocus',
                        'BlockPublishTask',
                        'AthleteTransferredTrack',
                        'AthleteTransferredBlock',
                    ];
                case 'TeamCoach_BlockBuilder':
                case 'CrossTeamBlock_Readonly':
                    return [
                        'Block',
                        'BlockFocus',
                        'TrainingFocus',
                        'BlockDraftWorkoutLayer',
                        'BlockPublishedWorkoutLayer',
                        'AthleteDraftWorkoutLayer',
                        'AthletePublishedWorkoutLayer',
                        'AthleteModifiedPublishedWorkoutLayer',
                        'AthleteActualWorkoutLayer',
                        'BlockPublishTask',
                        'BlockPrintTask',
                        'AmsClassicWorkout',
                    ];
                case 'TeamCoach_BulkActuals':
                    return [
                        'Block',
                        'BlockPublishedWorkoutLayer',
                        'AthletePublishedWorkoutLayer',
                        'AthleteModifiedPublishedWorkoutLayer',
                        'AthleteActualWorkoutLayer',
                        'AmsClassicWorkout',
                    ];
                case 'TeamCoach_TabletAthlete':
                    return [
                        'Block',
                        'Track',
                        'BlockPublishedWorkoutLayer',
                        'AthletePublishedWorkoutLayer',
                        'AthleteModifiedPublishedWorkoutLayer',
                        'AthleteActualWorkoutLayer',
                    ];
                case 'TeamCoach_Calendar':
                    return [
                        'Block',
                        'BlockPublishedWorkoutLayer',
                        'AthletePublishedWorkoutLayer',
                        // The calendar derives in-progress workout statuses (drag
                        // blocking) from actuals, like the builder does.
                        'AthleteActualWorkoutLayer',
                    ];
            }
        },
        equals: syncGroupsEqual,
    },
};
export function syncGroupsEqual(a, b) {
    switch (a.type) {
        case 'OrgCoach':
            return a.type === b.type;
        case 'TeamCoach':
        case 'TeamCoach_Timeline':
            return a.type === b.type && a.teamId === b.teamId;
        case 'TeamCoach_BlockBuilder':
        case 'CrossTeamBlock_Readonly':
            return a.type === b.type && a.blockId === b.blockId;
        case 'TeamCoach_BulkActuals':
            return (a.type === b.type &&
                a.teamId === b.teamId &&
                a.date === b.date &&
                // Timezone moves utcDayRange's day boundaries, so a timezone-only
                // change must re-bootstrap — same rule as TeamCoach_TabletAthlete.
                a.timezone === b.timezone);
        case 'TeamCoach_TabletAthlete':
            return (a.type === b.type &&
                a.teamId === b.teamId &&
                a.athleteId === b.athleteId &&
                a.date === b.date &&
                // Timezone moves the window's timestamp boundaries (startIso), so a
                // timezone-only change (kiosk moved zones) must re-bootstrap (SC-5518).
                a.timezone === b.timezone);
        case 'TeamCoach_Calendar':
            return (a.type === b.type &&
                a.teamId === b.teamId &&
                a.athleteId === b.athleteId &&
                a.date === b.date);
    }
}
//# sourceMappingURL=config.js.map